export default {
    NotActive: '#1890ff',
    Normal: '#52c41a',
    Alarm: '#f5222d',
    Offline: '#d9d9d9',
    Lose: '#faad14',
}